import { Routes, Route,Link} from "react-router-dom";
// import First from "./Other/First";
import Home from "./Home";

function App() {
  return (
   <>
  <Home/>

   </>
  )
}

export default App;
